import btnCtaSVGTemplate from '../../../svgs/btn-cta-hover.svg';

export const btnCtaDirectiveModule = angular
  .module('Q.components.btn-cta', [])

  .directive('btnCta', function () {
    return {
      restrict: 'A',
      link: function (scope, el, attr) {
        const text = attr.btnCta || el.text();
        el.empty();
        el.addClass('btn-cta');
        el.append(btnCtaSVGTemplate);
        const span = angular.element('<span>');
        span.text(text);
        el.append(span);
      },
    };
  });
